<template>
      <el-dialog title="编辑属性值" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false"
        :close-on-press-escape="false">
      <el-form size="small" ref="form">

        <el-form-item label="属性值：">
          <el-input 
            type = "textarea" 
            :maxlength = "500" 
            :rows = "3"
            placeholder = "一行为一个属性值,多个属性值用;号输入"
            v-model = "attr_val">
          </el-input>
        </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="postAttr" :loading="loading">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    data() {
      return {
        attr_val:'',
        /*左边长度*/
        formLabelWidth: '120px',
        /*是否显示*/
        dialogVisible: false,
        loading: false,
      };
    },
    props: ['is_attr', 'wholesaleList','attr_index','attr_value'],
    created() {
      this.dialogVisible = this.is_attr;
      this.attr_val = this.attr_value
      // console.log(this.wholesaleList,this.attr_index)
    },
    methods: {

      /*关闭弹窗*/
      dialogFormVisible(e) {
        if (e) {
          this.$emit('closeDialog', {
            type: 'success',
            openDialog: false
          })
        } else {
          this.$emit('closeDialog', {
            type: 'error',
            openDialog: false
          })
        }
      },
      // 提交属性
      postAttr()
      {
        this.wholesaleList[this.attr_index].attr_value = this.attr_val
        this.dialogVisible = false
      }
    }
  };
</script>




// WEBPACK FOOTER //
// src/views/product/attribute/attr.vue